module.exports = __webpack_public_path__ + "static/media/enchanting-thumbnail1.e727f097.png";